<template>
<div>
  <div class="vx-row">

   

    <!-- MULTIPLE COLUMNS-->
    <div class="vx-col w-full mb-base">
      
      <vx-card title="">
        <div class="demo-alignment">
                  <vs-button @click="eslemeListesi()" color="success" type="filled">Eşleştirme Listesi</vs-button>
                  <vs-button @click="gonderimListesiGonder()" color="red" type="filled">Trendyol Ürünleri Gönder</vs-button>
                   <vs-button @click="activePrompt = true" color="warning"  id="button-with-loading-partile" class="vs-con-loading__container" type="filled">Toplu Fiyat Güncelle</vs-button>

            <vs-progress :percent="progress"  v-model="progress"  color="primary"></vs-progress>
        </div>
      </vx-card>
      <br/>

    </div>

<vs-prompt title="Fiyat İşlemleri" acceptText="İşlemi Başlat" cancelText="Vazgeç"
      @accept="fiyatGuncellemeBaslat"
      :active.sync="activePrompt">
      <div class="con-exemple-prompt">
        <span>Artırılacak Tutar</span>
      <vs-input type="number" placeholder="Yüzde Giriniz" vs-placeholder="Code" v-model="partiVal" class="mt-3 w-full" />
      </div>
    </vs-prompt>

  <div class="vx-row">



 <div class="vx-col w-1/8 mb-base" style="">

       <v-select  v-model="selected1"  :options="list"  label="name" 
     style="" @input="altkategori1($event)">
     
     </v-select>
      <br/>
 <v-select  v-model="selected2"  :options="listalt" label="name" 
     style="" @input="altkategori2($event)">
     
     </v-select>
      <br/>
     <v-select  v-model="selected3"  :options="listalt1"  label="name" 
     style="" @input="altkategori3($event)">
     
     </v-select>
      <br/>
    <v-select  v-model="selected4"  :options="listalt2"  label="name" 
     style="" @input="altkategori4($event)">
     
     </v-select>
      <br/>
    <v-select  v-model="selected5"  :options="listalt3"  label="name" 
     style="" @input="altkategori5($event)">
     
     </v-select>
      <br/>
      </div>




       <div class="vx-col w-1/8 mb-base" style="">

       <v-select  v-model="selected6"  :options="listMuhasebeAna"  :reduce="listMuhasebeAna => listMuhasebeAna.anakategori" label="anakategori" 
     style="" @input="muhasebeKategorileri1($event,1)">
     </v-select><br />
   <v-select  v-model="selected7"  :options="listMuhasebeAlt1"  :reduce="listMuhasebeAlt1 => listMuhasebeAlt1.altkategori1" label="altkategori1" 
     style="" @input="muhasebeKategorileri2($event,2)">
     </v-select><br />
     <v-select  v-model="selected8"  :options="listMuhasebeAlt2"  :reduce="listMuhasebeAlt2 => listMuhasebeAlt2.altkategori2" label="altkategori2" 
     style="" @input="muhasebeKategorileri3($event,3)">
     </v-select><br />

    <vs-button @click="kategoriEslestir()" color="success" type="filled">Kategori Eşleştir</vs-button>

      </div>


<div class="vx-col w-1/8 mb-base" style=""></div>

 <vs-table :data="eslestirmeListesiData">
        <template slot="thead">
          <vs-th>Pazaryeri Kategori</vs-th>
          <vs-th>Firma Kategori</vs-th>
          <vs-th></vs-th>
          <vs-th></vs-th>
        </template>

          <template slot-scope="{data}">
            <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                 {{ data[indextr].pazaryeriKategori }}
              </vs-td>
              <vs-td>
                {{ data[indextr].kategori1Ad }} -> {{ data[indextr].kategori2Ad }} -> {{ data[indextr].kategori3Ad }} -> {{ data[indextr].kategori4Ad }} ->
              </vs-td>
             <vs-td><vs-button @click="ozellikEsleme(data[indextr].pazaryeriId,data[indextr].id)" color="black" type="filled">Özellik Eşleştir</vs-button></vs-td>
             <vs-td><vs-button @click="eslestirmeSil(data[indextr].id)" color="red" type="filled"> Sil</vs-button></vs-td>
            </vs-tr>
          </template>

      </vs-table>

  </div>
    <div class="vx-col lg:w-4/4 w-full relative">

  

</div>

</div>
    

       <vs-popup fullscreen  class="holamundo" title="Özellik Eşleme" :active.sync="popupActiveSiparis">
         

         <div class="vx-row" style="height:250px;">
        <div class="vx-col w-1/8 mb-base" style="">
        <v-select  v-model="selectedO1"  :options="kategoriOzellikListesi"  label="attributeName" style="" @input="ozellikOzellikListesi"></v-select>
        </div>

         <div class="vx-col w-1/8 mb-base" style="">
        <v-select  v-model="selectedO3"  :options="ozellikOzellikleriData"  label="valueName" style=""></v-select>
        </div>

        <div class="vx-col w-1/8 mb-base" style="">
       <v-select  v-model="selectedO2"  :options="listOzellik"  label="baslik" @input="programAlanOzellikleri" style=""></v-select>
        </div>

        <div class="vx-col w-1/8 mb-base" style="">
        <v-select  v-model="selectedO4"  :options="listOzellikOzellik" label="alan"   style=""></v-select>
        </div>


        <div class="vx-col w-1/8 mb-base" style="">
        <vs-button @click="ozellikleriEsle" color="red" type="filled"> Eşleştir</vs-button>
        </div>

        </div>


             <vs-table :data="ozellikEslestirmeListesiData">
        <template slot="thead">
          <vs-th>Özellik</vs-th>
          <vs-th>Firma Alanı</vs-th>
          <vs-th></vs-th>
         
          <vs-th></vs-th>
        </template>

          <template slot-scope="{data}">
            <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                 {{ data[indextr].ozellikAdi }} {{ data[indextr].ozellikAltAd }}
              </vs-td>
              <vs-td>
               {{ data[indextr].programDeger }}
              </vs-td>
            
             <vs-td><vs-button @click="ozellikeslestirmeSil(data[indextr].id)" color="red" type="filled"> Sil</vs-button></vs-td>
            </vs-tr>
          </template>

      </vs-table>


        </vs-popup>   


        <vs-popup fullscreen  class="holamundo" title="Eşleşen Stok Listesi" :active.sync="popupEslesenStokListesi">
          <table>
            <tr>
              <td><vs-input class="inputx" placeholder="Stok Kodu" @keyup.enter="gonderimListesiHazirla()" :ref="stokKoduBul" v-model="stokKoduBul" /></td>
            </tr>
          </table>

        <vs-table :data="eslesenStokListesi">
        <template slot="thead">
          
          <vs-th>Stok Kodu</vs-th>
          <vs-th>Barkod</vs-th>
          <vs-th>Stok Adı</vs-th>
          <vs-th>Renk</vs-th>
          <vs-th>Beden</vs-th>
          <vs-th>Stok Adet</vs-th>
          <vs-th>Gönderilecek Miktar</vs-th>
          <vs-th>Gönderim Listesi</vs-th>
          <vs-th></vs-th>
         
          <vs-th></vs-th>
        </template>

          <template slot-scope="{data}">
            <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
              
              <vs-td>
                 {{ data[indextr].STOK_KODU }}
              </vs-td>
              <vs-td>
                 {{ data[indextr].BARKOD }}
              </vs-td>
              <vs-td>
               {{ data[indextr].STOK_ADI }}
              </vs-td>
               <vs-td>
               {{ data[indextr].renk }}
              </vs-td>
               <vs-td>
               {{ data[indextr].beden }}
              </vs-td>
              <vs-td>
               {{ data[indextr].stokAdet }}
              </vs-td>
              <vs-td>
                <input class="inputx" placeholder="Adet" :id="'adet_'+indextr"/>
              
              </vs-td>
            
              <vs-td>
                <span v-if="data[indextr].eslesmeDurumu == '-1'">
               <vs-button @click="gonderimListesineEkle(data[indextr].STOK_KODU,indextr,data[indextr].BARKOD,data[indextr].alan1,data[indextr].alan2,data[indextr].alan3,data[indextr].alan4,data[indextr].alan5,data[indextr].alan6,data[indextr].alan7,data[indextr].alan8,data[indextr].alan9,data[indextr].alan10,data[indextr].renk,data[indextr].beden,data[indextr].SATIS_FIAT1,data[indextr].stokAdet)" color="success" :id="'b_'+indextr" class="vs-con-loading__container" type="filled">Listeye Ekle</vs-button>
                </span>
                
              </vs-td>
            
            </vs-tr>
          </template>

      </vs-table>


        </vs-popup>

        <vs-popup fullscreen  class="holamundo" title="Gönderilen Stok Listesi" :active.sync="popupGonderilenStokListesi">
         

        <vs-table :data="gonderilenStokListesi">
        <template slot="thead">
          
          <vs-th>Barkod</vs-th>
          <vs-th>Durum</vs-th>
          <vs-th>Alınan Hata</vs-th>
         
        
        </template>

          <template slot-scope="{data}">
            <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
              
              <vs-td>
                 {{ data[indextr].barcode }}
              </vs-td>
              <vs-td>
               {{ data[indextr].status }}
              </vs-td>
              <vs-td>
               {{ data[indextr].failureReasons }}
              </vs-td>
           
            
            </vs-tr>
          </template>

      </vs-table>


        </vs-popup>
           
    </div>


    
</template>



<script>
import state from '../../store/state'
import Store from '../../store/store'
import vSelect from 'vue-select'
export default {
  components: {
    'v-select': vSelect,
  },
  data () {
    return {
  activePrompt:false,
  list: [],
  listalt: [],
  listalt1: [],
  listalt2: [],
  listalt3: [],
  listEksik:[],
  listOzellik:[],
  listOzellikOzellik:[],
  kategoriSuz:[],
  listMuhasebeAna:[],
  listMuhasebeAlt1:[],
  listMuhasebeAlt2:[],
  listMuhasebeAlt3:[],
  listMuhasebeAlt4:[],
  listMuhasebeAlt5:[],
  listMuhasebeAlt6:[],
  listMuhasebeAlt7:[],
  listMuhasebeAlt8:[],
  listMuhasebeAlt9:[],
  listMuhasebeAlt10:[],
  eslestirmeListesiData:[],
  ozellikEslestirmeListesiData:[],
  kategoriOzellikListesi:[],
  programOzellikListesi:[],
  eslesenStokListesi:[],
  gonderilenStokListesi:[],
  sanakategori:'',
  salt1Kategori:'',
  salt2Kategori:'',
  salt3Kategori:'',
  salt4Kategori:'',
  salt5Kategori:'',
  salt6Kategori:'',
  salt7Kategori:'',
  salt8Kategori:'',
  salt9Kategori:'',
  salt10Kategori:'',
  partiVal:'',
  progress:0,
  alt1Kategori:"",
  alt2Kategori:"",
  alt3Kategori:"",
  sonSecilenKategori:0,
  selected1:{id: 0, name: 'Kategoriler'},
  selected2:{id: 0, name: 'Kategoriler'},
  selected3:{id: 0, name: 'Kategoriler'},
  selected4:{id: 0, name: 'Kategoriler'},
  selected5:{id: 0, name: 'Kategoriler'},
  selected6:{id: 0, name: 'Kategoriler'},
  selected7:{id: 0, name: 'Kategoriler'},
  selected8:{id: 0, name: 'Kategoriler'},
  selectedOzellik:{name: 'Kategoriler'},
  selectedO1:{attributeid: 0, attributeName: 'Pazaryeri Başlıkları'},
  selectedO3:{valueId: 0, valueName: 'Pazaryeri Özellikleri'},
  selectedO2:{id: 0, programAlan: 'Muhasebe Alanları'},
  selectedO4:{alan: 'Seçenekler'},

  ozelliklerDiv:"", 
  kategoriSira:0,
  kategoriSira1:0,
  muhasebeKategoriSonSecilen:'',
  popupActiveSiparis: false,
  popupEslesenStokListesi:false,
  popupGonderilenStokListesi:false,
  ozellikEslemeKategori:0,
  ozellikOzellikleri:[],
  ozellikOzellikleriData:[],
  stokKoduBul:'',
  gonderilecekAdet:0
    }
  },methods: {
    fiyatGuncellemeBaslat() {
      //alert("sss");
         const vm = this
      var vs=this.$vs
      const soap = require('soap')
      const url = state.sistemAddress
      const args = {pazaryeri: 'Trendyol',yuzde:this.partiVal,token:Store.state.tokenId}

      vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: "#button-with-loading-partile",
        scale: 0.45
      })


      soap.createClient(url, function(err, client){
      client.topluFiyatGuncelleme(args, function(err, result){
        if (result.partileResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
        }

      vm.veriler=JSON.parse(result.topluFiyatGuncellemeResult)
      console.log(vm.veriler)
        if (vm.veriler.response=='Ok') {
          vs.loading.close("#button-with-loading-partile > .con-vs-loading")
          vs.notify({
            title: 'Fiyat Güncelleme',
            text: "Güncelleme İşlemi Başarılı",
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success',
            position:'top-center'
          })

        } else {
          vs.notify({
            title: 'Fiyat Güncelleme',
            text: "Fiyat Güncellemede Hata Oluştu",
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'error',
            position:'top-center'
          })
        }
      })
      })
    },
    gonderimListesineEkle(stokKodu,id,barkod,alan1,alan2,alan3,alan4,alan5,alan6,alan7,alan8,alan9,alan10,renk,beden,fiyat,adet) {
     
//alert(document.getElementById('adet_'+id).value)
var vs = this.$vs
     vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: "#b_"+id,
        scale: 0.45
      })


      var vm = this

    const soap = require('soap')
      const url = state.sistemAddress
     
     if (document.getElementById("adet_"+id).value=="") {
       vm.gonderilecekAdet=adet
     } else {
       vm.gonderilecekAdet=document.getElementById("adet_"+id).value
     }
      const args = {token:Store.state.tokenId,program:'Trendyol',stokKodu:stokKodu,durum:1,barkod:barkod,gonderilecekAdet:vm.gonderilecekAdet,alan1:alan1,alan2:alan2,alan3:alan3,alan4:alan4,alan5:alan5,alan6:alan6,alan7:alan7,alan8:alan8,alan9:alan9,alan10:alan10,renk:renk,beden:beden,fiyat:fiyat,adet:adet}
      soap.createClient(url, function(err, client){
      client.gonderimListesineEkle(args, function(err, result){
        if (result.gonderimListesineEkleResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
        }

       vm.veriler=JSON.parse(result.gonderimListesineEkleResult)
       console.log(vm.veriler)
        vm.resimYukle(result.gonderimListesineEkleResult,0,id)
        
      /* for (let s=0; s<vm.veriler.length;s++) {
          ///console.log(vm.veriler[s])
          const f = vm.veriler[s].split("\\")
          const t=f.length
          const t1=t-1
         /// console.log(f[t1])
           const args1 = {resimYolu:vm.veriler[s],resimAdi:f[t1]}
           client.ftpResimYukle(args1, function(){
           })
        }*/
    
       // vm.eslesenStokListesi=vm.veriler
        
        
      })
     
      })


    },
    resimYukle(resimler,sayi,id) {
      var vs = this.$vs
      const tumResimler=JSON.parse(resimler)
      const resimSayisi=tumResimler.length
      var vm = this
      if (resimSayisi>0) {
          const f = tumResimler[sayi].split("\\")
          const t=f.length
          const t1=t-1
         /// console.log(f[t1])
         const soap = require('soap')
      const url = state.sistemAddress
           const args1 = {resimYolu:tumResimler[sayi],resimAdi:f[t1]}
           soap.createClient(url, function(err, client){
           client.ftpResimYukle(args1, function(erri,result){
             console.log(result.ftpResimYukleResult)
             if (result.ftpResimYukleResult=="Ok") {
              // alert("burda")
               sayi=sayi+1
               if (sayi<resimSayisi) {
                 vm.resimYukle(resimler,sayi,id)
               } else {
                 //alert("bitti")
                  vs.loading.close("#b_"+id+" > .con-vs-loading")
                  document.getElementById("b_"+id).disabled=true
               }
             }
           })
           })
      } else {
        vs.loading.close("#b_"+id+" > .con-vs-loading")
                  document.getElementById("b_"+id).disabled=true
      }
    },
    gonderimListesiHazirla() {
      this.eslesenStokListesi=[]
      this.popupEslesenStokListesi=true
         var vm = this

    const soap = require('soap')
      const url = state.sistemAddress
     
      const args = {token:Store.state.tokenId,program:'Trendyol',stokKodu:this.stokKoduBul}
      soap.createClient(url, function(err, client){
      client.eslesenStokListesi(args, function(err, result){
        if (result.programAlanlariResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
        }
        
        vm.veriler=JSON.parse(result.eslesenStokListesiResult)
        
        vm.eslesenStokListesi=vm.veriler
        
        
      })
      })
      
    },
     trendyolAktarumDurum(kod) {
var vm = this
           const soap = require('soap')
      const url = state.sistemAddress


       const args={program:'Trendyol',durumKodu:kod}
        soap.createClient(url, function(err, client){
      client.aktarimDurumSorgula(args, function(err, result){
       // console.log(result1.aktarimDurumSorgulaResult)
        vm.veriler=JSON.parse(result.aktarimDurumSorgulaResult)
        vm.gonderilenStokListesi=vm.veriler
       //console.log(vm.veriler)
        
      })
        })

    },
    gonderimListesiGonder() {
     this.popupGonderilenStokListesi=true
         var vm = this

    const soap = require('soap')
      const url = state.sistemAddress
     
      const args = {program:'Trendyol',token:Store.state.tokenId}
      soap.createClient(url, function(err, client){
      client.StokAktarToplu(args, function(err, result){
        if (result.StokAktarTopluResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
        }


         var sonuc=result.StokAktarTopluResult
       
     //  const userStr = JSON.stringify(sonuc);
        vm.veriler=JSON.parse(sonuc)
        const d=JSON.parse(vm.veriler)
    console.log(vm.veriler)
    console.log(vm.veriler.batchRequestId)
    console.log(vm.veriler['batchRequestId'])
    console.log(d.batchRequestId)
    console.log(d['batchRequestId'])
    const batch=d['batchRequestId']
    /*if (typeof batch!='undefined') {
     batch =d.batchRequestId
    }*/

   console.log(batch)
    if (typeof batch!='undefined') {
      console.log("gonderildi")
      vm.trendyolAktarumDurum(d['batchRequestId'])
    } else {

      vs.notify({
            title: 'Trendyol Gönderim Hatalı',
            text: d.errors[0].message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
            position:'top-center'
          })
        vm.trendyolDurumMesaji=d.errors[0].message
    }
        
      })
      })
      
    },
    programAlanOzellikleri() {
     // console.log(this.ozellikEslemeKategori)
    //  console.log(this.selectedO2.programAlan)
      

        var vm = this

    const soap = require('soap')
      const url = state.sistemAddress
     //alert(this.ozellikEslemeKategori+' '+baslik)
      const args = {id:this.ozellikEslemeKategori,alan:this.selectedO2.baslik}
      soap.createClient(url, function(err, client){
      client.programAlanlari(args, function(err, result){
        if (result.programAlanlariResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
        }

        vm.veriler=JSON.parse(result.programAlanlariResult)
        vm.listOzellikOzellik=vm.veriler

        
      })
      })


    }
    ,
    ozellikleriEsle() {
      //alert(this.selectedO1.attributeid+' '+this.selectedO1.attributeName)

      var vm = this

    const soap = require('soap')
      const url = state.sistemAddress
     
      const args = {program:'Trendyol',token:Store.state.tokenId,kategoriId:this.ozellikEslemeKategori,ozellikId:this.selectedO1.attributeid,ozellikAdi:this.selectedO1.attributeName,programAlan:this.selectedO2.programAlan,programDeger:this.selectedO4.alan,ozellikAltId:this.selectedO3.valueId,ozellikAltAd:this.selectedO3.valueName}
      soap.createClient(url, function(err, client){
      client.ozellikleriEsle(args, function(err, result){
        if (result.ozellikleriEsleResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
        }

        vm.ozellikEslemeListesi()
      })
      })

    },
    ozellikEsleme(pazaryeriId,id) {
     
      this.sonSecilenKategori=pazaryeriId
      this.ozellikEslemeKategori=id
      this.ozellikEslemeListesi()
      this.kategoriOzellikleri()
      this.popupActiveSiparis=true
    },
    eslestirmeSil(id) {
       var vm = this

    const soap = require('soap')
      const url = state.sistemAddress
     
      const args = {id:id,token:Store.state.tokenId}
      soap.createClient(url, function(err, client){
      client.eslemeListesiSil(args, function(err, result){
        if (result.eslemeListesiSilResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
        }

        vm.eslemeListesi()
      })
      })
    },
    ozellikeslestirmeSil(id) {
       var vm = this

    const soap = require('soap')
      const url = state.sistemAddress
     
      const args = {id:id,token:Store.state.tokenId}
      soap.createClient(url, function(err, client){
      client.ozellikeslestirmeSil(args, function(err, result){
        if (result.ozellikeslestirmeSilResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
        }

        vm.ozellikEslemeListesi()
      })
      })
    },
    
    eslemeListesi() {
      var vm = this

    const soap = require('soap')
      const url = state.sistemAddress
     
      const args = {program:'Trendyol',token:Store.state.tokenId}
      soap.createClient(url, function(err, client){
      client.eslemeListesi(args, function(err, result){
        if (result.eslemeListesiResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
        }
      vm.veriler=JSON.parse(result.eslemeListesiResult)
      vm.eslestirmeListesiData=vm.veriler
      })
      })
    },
    ozellikEslemeListesi() {
      var vm = this

    const soap = require('soap')
      const url = state.sistemAddress
     
      const args = {program:'Trendyol',token:Store.state.tokenId,kategoriId:this.ozellikEslemeKategori}
      soap.createClient(url, function(err, client){
      client.ozellikEslenenlerListesi(args, function(err, result){
        if (result.ozellikEslenenlerListesiResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
        }
        console.log(result.ozellikEslenenlerListesiResult)
      vm.veriler=JSON.parse(result.ozellikEslenenlerListesiResult)
      vm.ozellikEslestirmeListesiData=vm.veriler
      
      })
      })
    },
   kategoriOzellikleri() {
    
     var vm = this
      
      const soap = require('soap')
      const url = state.sistemAddress
      const args = {pazaryeri: 'Trendyol',token:Store.state.tokenId,categoryId:this.sonSecilenKategori}
      soap.createClient(url, function(err, client){
      client.pazaryeriKategoriOzellik(args, function(err, result){
        if (result.pazaryeriKategoriOzellikResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
        }
        
        vm.veriler=JSON.parse(result.pazaryeriKategoriOzellikResult)
        console.log(result.pazaryeriKategoriOzellikResult)
        vm.kategoriSuz=vm.veriler["json"]
         let ozellikler=vm.veriler["json"]
         //console.log(result.pazaryeriKategoriOzellikResult)
         vm.ozellikOzellikleri=ozellikler
         //console.log(vm.ozellikOzellikleri)
         const kategoriOzellik = [...new Set(ozellikler.map(x=>x.attributeid))]
         //console.log(kategoriOzellik)
         //vm.ozelliklerDiv=""
        vm.kategoriOzellikListesi=[]
        for (let s=0; s<kategoriOzellik.length;s++) {
           vm.indext = vm.indexbul(vm.kategoriSuz, item => item.attributeid === kategoriOzellik[s])
          vm.kategoriOzellikListesi.push({attributeName:vm.kategoriSuz[parseInt(vm.indext)]["attributeName"],attributeid:vm.kategoriSuz[parseInt(vm.indext)]["attributeid"]})
        }
    
        //=kategoriOzellik
        
        // vm.ozelliklerDiv=vm.a
        
        // document.createElement(a)
      //vm.veriler=JSON.parse(result.pazaryeriKategoriCekResult)
      //vm.list=vm.veriler

      })
      })
   },
   ozellikOzellikListesi() {
    console.log(this.ozellikOzellikleri)
     this.ozellikOzellikleriData = this.ozellikOzellikleri.filter(d => d.attributeid === this.selectedO1.attributeid);
      
   }
   ,
   ozellikEsle(attid) {
     alert(attid)
   },
  kategoriEslestir() {
   
    var vm = this
    const vs=this.$vs
    const soap = require('soap')
      const url = state.sistemAddress
     
      const args = {program:'Trendyol',token:Store.state.tokenId,pazaryeriId:vm.sonSecilenKategori,pazaryeriKategori:vm.muhasebeKategoriSonSecilen,kategori1Ad:vm.sanakategori,kategori2Ad:vm.salt1Kategori,kategori3Ad:vm.salt2Kategori,kategori4Ad:vm.salt3Kategori}
      soap.createClient(url, function(err, client){
      client.kategorileriEsle(args, function(err, result){
        if (result.kategorileriEsleResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
        }
      vm.veriler=JSON.parse(result.kategorileriEsleResult)
       if (vm.veriler.response=='No') {
             vs.notify({
                title: 'Kategori Eşleme',
                text: "Kategori Daha Önce Eşitlenmiş",
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning',
                position:'top-center'
              })

          } else {
            vm.eslemeListesi()
          }
      })
      })
  //console.log(this.selected.label)
  },
   indexbul(array, conditionFn) {
     //console.log(array)
        const item = array.find(conditionFn)
        return array.indexOf(item)
      },
   muhasebeKategorileri(gelen) {

     if (gelen!='') { 
         
         this.sanakategori=gelen

     }
    
     this.validated1=true
     this.validated=false
     var vm = this
      
      const soap = require('soap')
      const url = state.sistemAddress
      const args = {token:Store.state.tokenId,kategoriSira:vm.kategoriSira,anakategori:vm.sanakategori,alt1:vm.salt1Kategori,alt2:'',alt3:'',alt4:'',alt5:'',alt6:'',alt7:'',alt8:'',alt9:'',alt10:''}
      soap.createClient(url, function(err, client){
      client.muhasebeKategoriListesi(args, function(err, result){
        if (result.muhasebeKategoriListesiResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
        }
   
      vm.veriler=JSON.parse(result.muhasebeKategoriListesiResult)
      vm.listMuhasebeAna=vm.veriler;
     vm.kategoriSira=1
      })
      })


   },
   muhasebeKategorileri1(gelen) {

    this.kategoriSira=1
     this.validated1=true
     this.validated=false
     var vm = this
     vm.sanakategori=gelen
      const soap = require('soap')
      const url = state.sistemAddress
      const args = {token:Store.state.tokenId,kategoriSira:vm.kategoriSira,anakategori:gelen,alt1:'',alt2:'',alt3:'',alt4:'',alt5:'',alt6:'',alt7:'',alt8:'',alt9:'',alt10:''}
      soap.createClient(url, function(err, client){
      client.muhasebeKategoriListesi(args, function(err, result){
        if (result.muhasebeKategoriListesiResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
        }
   
      vm.veriler=JSON.parse(result.muhasebeKategoriListesiResult)
      vm.listMuhasebeAlt1=[]
      vm.listMuhasebeAlt1=vm.veriler;
      vm.kategoriSira=2
      })
      })


   },
   muhasebeKategorileri2(gelen) {

   
     this.validated1=true
     this.validated=false
     var vm = this
     vm.salt1Kategori=gelen
      const soap = require('soap')
      const url = state.sistemAddress
      const args = {token:Store.state.tokenId,kategoriSira:vm.kategoriSira,anakategori:vm.sanakategori,alt1:gelen,alt2:'',alt3:'',alt4:'',alt5:'',alt6:'',alt7:'',alt8:'',alt9:'',alt10:''}
      soap.createClient(url, function(err, client){
      client.muhasebeKategoriListesi(args, function(err, result){
        if (result.muhasebeKategoriListesiResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
        }
   
      vm.veriler=JSON.parse(result.muhasebeKategoriListesiResult)
      vm.listMuhasebeAlt2=vm.veriler;
     
      })
      })


   },
   muhasebeKategorileri3(gelen) {

    
     this.validated1=true
     this.validated=false
     var vm = this
     vm.salt2Kategori=gelen
      const soap = require('soap')
      const url = state.sistemAddress
      const args = {token:Store.state.tokenId,kategoriSira:vm.kategoriSira,anakategori:vm.salt1Kategori,alt1:this.salt2Kategori,alt2:gelen,alt3:'',alt4:'',alt5:'',alt6:'',alt7:'',alt8:'',alt9:'',alt10:''}
      soap.createClient(url, function(err, client){
      client.muhasebeKategoriListesi(args, function(err, result){
        if (result.muhasebeKategoriListesiResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
        }
     
      vm.veriler=JSON.parse(result.muhasebeKategoriListesiResult)
      vm.listMuhasebeAlt3=vm.veriler;
     
      })
      })


   },
   pazaryeriKategorileri() {
     
     this.validated1=true
     this.validated=false
     var vm = this
      
      const soap = require('soap')
      const url = state.sistemAddress
      const args = {pazaryeri: 'Trendyol',token:Store.state.tokenId,id:0,derinlik:0,json:''}
      soap.createClient(url, function(err, client){
      client.pazaryeriKategoriCek(args, function(err, result){
        if (result.pazaryeriKategoriCekResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
        }
      
      vm.veriler=JSON.parse(result.pazaryeriKategoriCekResult)
      vm.list=vm.veriler

      })
      })
this.muhasebeKategorileri('',0)
this.ozellikListesi()

   },
   ozellikListesi() {
     
     this.validated1=true
     this.validated=false
     var vm = this
      
      const soap = require('soap')
      const url = state.sistemAddress
      const args = {pazaryeri: 'Trendyol',token:Store.state.tokenId,id:0,derinlik:0,json:''}
      soap.createClient(url, function(err, client){
      client.ozellikEslemeListesi(args, function(err, result){
        if (result.ozellikEslemeListesiResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
        }
        
       
      vm.veriler=JSON.parse(result.ozellikEslemeListesiResult)
      vm.listOzellik=vm.veriler

      })
      })


   },
   ps1(text) {
      this.partiVal=text
    },
   altkategori1(id) {
     id=this.selected1.id
     this.muhasebeKategoriSonSecilen=this.selected1.name
     this.sonSecilenKategori=id
     this.validated1=true
     this.validated=false
     var vm = this
      
      const soap = require('soap')
      const url = state.sistemAddress
      const args = {pazaryeri: 'Trendyol',token:Store.state.tokenId,id:vm.selected1.id,derinlik:1,json:''}
      soap.createClient(url, function(err, client){
      client.pazaryeriKategoriCek(args, function(err, result){
        if (result.pazaryeriKategoriCekResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
        }
      vm.alt1Kategori=result.pazaryeriKategoriCekResult
      vm.veriler=JSON.parse(result.pazaryeriKategoriCekResult)
      vm.listalt=vm.veriler['categories']
               // console.log(vm.listalt)
      })
      })
        },
    altkategori2(id) {
      id=this.selected2.id
      this.muhasebeKategoriSonSecilen=this.selected2.name
          this.sonSecilenKategori=id
     this.validated1=true
     this.validated=false
     var vm = this
      
      const soap = require('soap')
      const url = state.sistemAddress
      const args = {pazaryeri: 'Trendyol',token:Store.state.tokenId,id:vm.selected2.id,derinlik:2,json:this.alt1Kategori}
      soap.createClient(url, function(err, client){
      client.pazaryeriKategoriCek(args, function(err, result){
        if (result.pazaryeriKategoriCekResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
        }
      vm.alt2Kategori=result.pazaryeriKategoriCekResult
      vm.veriler=JSON.parse(result.pazaryeriKategoriCekResult)
      vm.listalt1=vm.veriler['categories']
               // console.log(vm.listalt)
      })
      })
        },
    altkategori3(id) {
      id=this.selected3.id
      this.muhasebeKategoriSonSecilen=this.selected3.name
          this.sonSecilenKategori=id
     this.validated1=true
     this.validated=false
     var vm = this
      
      const soap = require('soap')
      const url = state.sistemAddress
      const args = {pazaryeri: 'Trendyol',token:Store.state.tokenId,id:vm.selected3.id,derinlik:2,json:this.alt2Kategori}
      soap.createClient(url, function(err, client){
      client.pazaryeriKategoriCek(args, function(err, result){
        if (result.pazaryeriKategoriCekResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
        }
      vm.alt3Kategori=result.pazaryeriKategoriCekResult
      vm.veriler=JSON.parse(result.pazaryeriKategoriCekResult)
      vm.listalt2=vm.veriler['categories']
               // console.log(vm.listalt)
      })
      })
        },
    altkategori4(id) {
      id=this.selected4.id
      this.muhasebeKategoriSonSecilen=this.selected4.name
          this.sonSecilenKategori=id
     this.validated1=true
     this.validated=false
     var vm = this
     
      const soap = require('soap')
      const url = state.sistemAddress
      const args = {pazaryeri: 'Trendyol',token:Store.state.tokenId,id:vm.selected4.id,derinlik:2,json:this.alt3Kategori}
      soap.createClient(url, function(err, client){
      client.pazaryeriKategoriCek(args, function(err, result){
        if (result.pazaryeriKategoriCekResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
        }
      //vm.alt3Kategori=result.pazaryeriKategoriCekResult
      vm.veriler=JSON.parse(result.pazaryeriKategoriCekResult)
      vm.listalt3=vm.veriler['categories']
               // console.log(vm.listalt)
      })
      })
        },
    altkategori5() {
    this.sonSecilenKategori=this.selected5.id
    this.muhasebeKategoriSonSecilen=this.selected5.name
        }
   
  },
  watch: {
    list: {
      handler: function () {
       
        //this.toplamParca=this.list.reduce((acc, item) => Number(acc) + (Number(item.siparisAdetleri)), 0)
        this.toplamParca=this.list.reduce((sum, item) => sum + item.siparisAdetleri, 0);
      },
      deep: true
    }
  },beforeMount(){
      this.pazaryeriKategorileri(0)
              }
  
}

</script>
<style lang="scss" scoped>
.mb-base { margin-bottom: 0.75rem!important;}
.list-view-item {
    .item-name, .item-description {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }

    .item-name {
        -webkit-line-clamp: 2;
    }

    .item-description {
        -webkit-line-clamp: 5;
    }

    .grid-view-img {
        max-width: 100%;
        max-height: 100%;
        width: auto;
        transition: .35s;
    }

    &:hover {
        transform: translateY(-5px);
        box-shadow: 0px 4px 25px 0px rgba(0,0,0,.25);

        .grid-view-img{
            opacity: 0.9;
        }
    }
}
</style>
